/**
 * Game Configuration
 * Modify these settings to customize the game behavior
 */

export const GAME_CONFIG = {
    /**
     * Language Settings
     * Available options: 'en' (English), 'zh' (中文)
     * Default: 'en'
     *
     * To change language to Chinese, modify this to 'zh':
     * language: 'zh'
     */
    language: 'en',

    /**
     * Game Difficulty
     * Available options: 'easy', 'normal', 'hard'
     * Default: 'normal'
     */
    difficulty: 'normal',

    /**
     * Audio Settings
     */
    audio: {
        enabled: true,
        musicVolume: 0.5,
        sfxVolume: 0.7
    },

    /**
     * Display Settings
     */
    display: {
        showFPS: false,
        showDebugInfo: false
    }
};
